import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';
import type { Channel, Video } from '../lib/types';
import { VideoCard } from '../components/VideoCard';

export function ChannelView(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [channel, setChannel] = useState<Channel | null>(null);
  const [videos, setVideos] = useState<Video[]>([]);

  useEffect(() => {
    if (!id) return;
    api.getChannel(id).then(setChannel);
    api.listVideos(id).then(setVideos);
  }, [id]);

  if (!channel) return <div style={{ padding: 30 }}>読み込み中…</div>;

  return (
    <div style={{ padding: '0 0 60px' }}>
      <div style={{ background: channel.tint, padding: '34px 30px', color: '#fff' }}>
        <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 8 }}>チャンネル</div>
        <h1 style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: 28, margin: '0 0 10px' }}>
          {channel.name}
        </h1>
        <div style={{ fontSize: 13, opacity: 0.9, maxWidth: '60ch', lineHeight: 1.7 }}>{channel.description}</div>
        <div style={{ display: 'flex', gap: 20, marginTop: 18, fontSize: 12.5, opacity: 0.9 }}>
          <span>動画 {channel.count ?? videos.length}本</span>
          {channel.updated && <span>最終更新 {channel.updated}</span>}
        </div>
      </div>
      <div style={{ padding: '26px 30px 0' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(248px, 1fr))', gap: 20 }}>
          {videos.map((v) => (
            <VideoCard key={v.videoId} video={v} />
          ))}
        </div>
      </div>
    </div>
  );
}
